import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 30px;
  gap: 24px;
`;

export const Title = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
`;

export const RowsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
`;

export const InputsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
`;

export const ErrorText = styled.span`
  color: #d14343;
  font-size: 14px;
`;

export const EmptyMessage = styled.div`
  padding: 40px;
  border-radius: 12px;
  background: #ffffff;
  text-align: center;
  color: #6b7280;
  font-size: 16px;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
`;
